import { ofType } from "redux-observable";
import { map, switchMap, mergeMap } from "rxjs/operators";
import { getJSON, postJSON, putJSON, deleteJSON } from "../utils/ajaxUtil";
import {
  REQUESTED_PRODUCT_GROUPS,
  REQUESTED_CREATE_PRODUCT_GROUP,
  REQUESTED_UPDATE_PRODUCT_GROUP,
  REQUESTED_DELETE_PRODUCT_GROUP,
  receiveProductGroups,
  receiveCreateProductGroup,
  receiveUpdateProductGroup,
  receiveDeleteProductGroup,
} from "../redux/actions/productGroupAction";

export const fetchProductGroupsByUser = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PRODUCT_GROUPS),
    map((action) => action.payload.user),
    switchMap((user) =>
      getJSON(`/productGroups`).pipe(
        map((res) => receiveProductGroups(res.data))
      )
    )
  );

export const createProductGroup = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CREATE_PRODUCT_GROUP),
    map((action) => action.payload.productGroup),
    mergeMap((productGroup) =>
      postJSON(`/productGroups/`, productGroup).pipe(
        map((res) => receiveCreateProductGroup(res.response.data))
      )
    )
  );

export const updateProductGroup = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_PRODUCT_GROUP),
    map((action) => action.payload.productGroup),
    mergeMap((productGroup) =>
      putJSON(
        `/productGroups/${productGroup.id}/`,
        productGroup.productGroup
      ).pipe(map((res) => receiveUpdateProductGroup(res.response.data)))
    )
  );

export const deleteProductGroup = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_PRODUCT_GROUP),
    map((action) => action.payload.productGroup),
    switchMap((productGroup) =>
      deleteJSON(`/productGroups/${productGroup.id}/`).pipe(
        map((res) => receiveDeleteProductGroup(res.response.data))
      )
    )
  );
